<template>
  <v-app id="catalog-app" class="outfit-font">
    <AppLayout>
      <template #content>
        <v-card-text>

          <!--Featured Cards-->
          <v-row v-if="FilteredProducts.length && ConfigShowFeaturedCards">
            <v-col cols="12" lg="3" md="3" sm="6">
              <FeaturedCard
                color="#efd7d6"
                btn-txt="Shop Now"
                @click="ShowPrinterOffers"
                title="Deal of the week"
                body="Save up to 20% on desktop printers"
                img-url="/wp-content/plugins/1-800-showroom/assets/img/sample-printer-1.png">
              </FeaturedCard>
            </v-col>
            <v-col cols="12" lg="3" md="3" sm="6">
              <FeaturedCard
                color="#daede4"
                btn-txt="View Deals"
                @click="ShowFastePrinterOffers"
                title="Exclusive Offers"
                body="Save on selected models"
                img-url="/wp-content/plugins/1-800-showroom/assets/img/sample-printer-2.png">
              </FeaturedCard>
            </v-col>
            <v-col cols="12" lg="3" md="3" sm="6">
              <FeaturedCard
                color="#5c8eff6e"
                btn-txt="Shop now"
                @click="OpenShop"
                title="Need Printer Supplies?"
                body="Check out our store for your needs"
                img-url="/wp-content/plugins/1-800-showroom/assets/img/sample-image-3.png">
              </FeaturedCard>
            </v-col>
            <v-col cols="12" lg="3" md="3" sm="6">
              <FeaturedCard
                color="#f3e6d6"
                btn-txt="Start"
                @action="OpenHelpWindow"
                title="Not sure what to choose?"
                body="Let our AI assistant help!"
                img-url="/wp-content/plugins/1-800-showroom/assets/img/sample-image-4.png">
              </FeaturedCard>
            </v-col>
          </v-row>

          <!--Sorter and Pagination-->
          <Flexed justify="space-between" class="mt-3 mb-3">
            <div style="color:rgba(0,0,0,0.6)" class="d-none d-md-block">{{ ActiveItemsShown }}</div>
            <v-spacer/>
            <v-select
              variant="plain"
              density="compact"
              class="page-sorting"
              :items="sort_types"
              :model-value="filters.sort_type"
              @update:model-value="SetSortFilter">
            </v-select>
          </Flexed>

          <!--Product Card For Loop-->
          <v-row id="the-products" v-if="!is_fetching">
            <v-col :id="p_index==0?'first-product':''" v-for="(product,p_index) in PaginatedProducts" :key="p_index" cols="12" lg="3" md="3" sm="6" xs="12">
              <ProductCard :product="product"/>
            </v-col>
          </v-row>

          <v-divider style="margin-top:30px;margin-bottom:20px"/>

          <!--Pagination-->
          <v-pagination
            v-if="!is_fetching"
            class="catalog-pagination"
            :active-color="ConfigElementsColor"
            v-model="active_page"
            density="comfortable"
            rounded="lg"
            color="#00000080"
            :length="TotalPages">
          </v-pagination>
        </v-card-text>

        <IsFetchingData/>
        <NoCopiersAvail :data="FilteredProducts"/>
        <Configurator v-if="selected_copier && configurator"/>
        <ViewProduct/>
        <AiAssistantUI/>
        <ReviewProductForm v-if="review_modal"/>
      </template>
      <template #footer>
        <ShopLink/>
      </template>
    </AppLayout>

    <Alerts/>
    <CartTable/>
    <QuoteForm v-if="form_modal && cart_items.length > 0"/>
  </v-app>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

// Imported Components
import AppLayout from "@/layouts/AppLayout.vue"
import Alerts from "@/components/misc/Alerts.vue"
import QuoteForm from "@/components/catalog/QuoteForm.vue"
import CartTable from "@/components/catalog/CartTable.vue"
import ProductCard from "@/components/catalog/ProductCard.vue"
import Configurator from "@/components/catalog/Configurator.vue"
import IsFetchingData from "@/components/catalog/IsFetchingData.vue"
import NoCopiersAvail from "@/components/catalog/NoCopiersAvail.vue"
import ViewProduct from "@/components/catalog/ViewProduct.vue"
import ShopLink from "@/components/misc/ShopLink.vue"
import Flexed from "./components/typography/Flexed.vue"
import FeaturedCard from "./components/catalog/FeaturedCard.vue"
import AiAssistantUI from "@/components/assistant/AiAssistantUI.vue"
import ReviewProductForm from "@/components/configurator/ReviewProductForm.vue"

// Global Pinia Store
const store = useGlobalsStore()
const {
  filters,
  products,
  cart_items,
  is_fetching,
  configurator,
  manufacturers,
  form_modal,
  active_form,
  selected_copier,
  sort_types,
  is_mobile,
  review_modal,
  ConfigShowFeaturedCards,
  ConfigElementsColor
} = storeToRefs(store)

// Component Local State
const active_page = ref(1)
const active_items = ref('')

// Methods
function DetectScreenSize() {
  is_mobile.value = window.innerWidth <= 768
}

function AddToCartFromURL() {
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has('add-to-cart')) {
    const product_id = urlParams.get('add-to-cart')
    const product = products.value.find(p => p.id == product_id)

    console.log("product: ", product)
    if (typeof product != 'undefined') {
      const current_items = [...cart_items.value]
      current_items.push({ product: product, datasets: [], quantity: 1 })
      store.SetCartItems(current_items)
      store.SetSuccess("1 item(s) added to quote")

      // We decide what type of form to show based on product
      if (product.manufacturer_id == 9) {
        active_form.value = 'mailing-form'
      }
      else if (product.form_factor.toLowerCase() == 'wide-format') {
        active_form.value = 'wide-format-form'
      }
      else if (product.printer_category.toLowerCase().includes('phone')) {
        active_form.value = 'phone-form'
      }
      else if (product.printer_category.toLowerCase() == 'scanner') {
        active_form.value = 'scanner-form'
      }
       else {
        active_form.value = 'default-form'
      }
    } else {
      store.SetError("Sorry, this item is longer available.")
    }
  }
}

function ConfigureFromURL() {
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has('configure')) {
    const product_id = urlParams.get('configure')
    const product = products.value.find(p => p.id == product_id)
    if (typeof product != 'undefined') {
      store.SetSelectedCopier(product)
      configurator.value = true
    } else {
      store.SetSelectedCopier(null)
      configurator.value = false
      store.SetError("Sorry, this item is longer available.")
    }
  }
}

function SetBrandFromURL() {
  const urlParams = new URLSearchParams(window.location.search)
  const brand_id = urlParams.get('brand')
  if (brand_id !== null) {
    const brand = manufacturers.value.find(m => +m.id === +brand_id)
    if (brand !== undefined) {
      const brandNum = Number(brand_id)
      const currentManufacturers = [...(filters.value.manufacturers as number[])]
      if (!currentManufacturers.includes(brandNum)) {
        currentManufacturers.push(brandNum)
        store.SetFilters({
          ...filters.value,
          manufacturers: currentManufacturers
        })
      }
    }
  }
}

function SetSortFilter(value: string | null) {
  const rawFilters = { ...filters.value }
  rawFilters.sort_type = value
  store.SetFilters(rawFilters)
}

function OpenShop() {
  window.open(store.ConfigShopURL, '_blank')
}

function ScrollToProductCards() {
  if (is_mobile.value) {
    document.querySelector('#the-products')?.scrollIntoView({ behavior: 'smooth' })
  }
}

function ShowPrinterOffers() {
  store.SetAnyState({ target: 'is_fetching', value: true })
  ScrollToProductCards()
  setTimeout(() => {
    const filtersCopy = { ...filters.value }
    filtersCopy.price_filters = [
      filtersCopy.price_options[0],
      filtersCopy.price_options[1]
    ]
    filtersCopy.device_types = ["Printer"]
    store.SetFilters(filtersCopy)
    store.SetAnyState({ target: 'is_fetching', value: false })
  }, 1000)
}

function ShowFastePrinterOffers() {
  ScrollToProductCards()
  store.SetAnyState({ target: 'is_fetching', value: true })
  setTimeout(() => {
    const filtersCopy = { ...filters.value }
    filtersCopy.price_filters = []
    filtersCopy.sort_type = null
    filtersCopy.device_types = ["Copier", "Wide-Format", "MFP"]
    store.SetFilters(filtersCopy)
    store.SetAnyState({ target: 'is_fetching', value: false })
  }, 1000)
}

function OpenHelpWindow() {
  store.OpenHelpWindow()
}

// Computed Properties
const FilteredProducts = computed(() => {
  let filteredProducts = [...products.value]
  active_page.value = 1

  if (filters.value.manufacturers.length > 0) {
    const manufacturerIds = filters.value.manufacturers as any[]
    filteredProducts = filteredProducts.filter(product =>
      manufacturerIds.includes(+product.manufacturer_id)
    )
  }
  if (filters.value.copier_colors.length > 0) {
    filteredProducts = filteredProducts.filter(product =>
      filters.value.copier_colors.includes(product.copier_color)
    )
  }
  if (filters.value.speed_minimum !== null && filters.value.speed_minimum >= 0 && filters.value.speed_maximum !== null && filters.value.speed_maximum > 0) {
    filteredProducts = filteredProducts.filter(product => {
      return (
        (product.speed_color < (filters.value.speed_maximum ?? 0) && product.speed_color > (filters.value.speed_minimum ?? 0)) ||
        (product.speed_black < (filters.value.speed_maximum ?? 0) && product.speed_black > (filters.value.speed_minimum ?? 0))
      )
    })
  }
  if (filters.value.paper_sizes.length > 0) {
    filteredProducts = filteredProducts.filter(product => {
      const paperSizesArray = Array.isArray(product.paper_size) ? product.paper_size : [product.paper_size]
      return filters.value.paper_sizes.some(size => paperSizesArray.includes(size))
    })
  }
  if (filters.value.product_categories.length > 0) {
    filteredProducts = filteredProducts.filter(product =>
      filters.value.product_categories.includes(product.printer_category)
    )
  }
  if (filters.value.form_factors.length > 0) {
    filteredProducts = filteredProducts.filter(product =>
      filters.value.form_factors.includes(product.form_factor)
    )
  }
  if (filters.value.capabilities.length > 0) {
    filteredProducts = filteredProducts.filter(product =>
      filters.value.capabilities.includes(product.capability)
    )
  }
  if (filters.value.connection_types.length > 0) {
    filteredProducts = filteredProducts.filter(product => {
      const product_connectivity = Array.isArray(product.connectivity) ? product.connectivity : [product.connectivity]
      return filters.value.connection_types.some(type => product_connectivity.includes(type))
    })
  }
  if (filters.value.usage_levels.length > 0) {
    filteredProducts = filteredProducts.filter(product =>
      filters.value.usage_levels.includes(product.usage_class)
    )
  }

  // Apply sorting
  if (filters.value.sort_type === 'ascending') {
    filteredProducts.sort((a, b) => a.name.localeCompare(b.name))
  }
  else if (filters.value.sort_type === 'descending') {
    filteredProducts.sort((a, b) => b.name.localeCompare(a.name))
  }
  /* Speed Sorter */
  else if (filters.value.sort_type === 'speed-low-high') {
    filteredProducts.sort((a, b) => {
      const speedA = a.speed_color > 0 ? a.speed_color : a.speed_black
      const speedB = b.speed_color > 0 ? b.speed_color : b.speed_black
      return speedA - speedB
    })
  }
  else if (filters.value.sort_type === 'speed-high-low') {
    filteredProducts.sort((a, b) => {
      const speedA = a.speed_color > 0 ? a.speed_color : a.speed_black
      const speedB = b.speed_color > 0 ? b.speed_color : b.speed_black
      return speedB - speedA
    })
  }
  else if (filters.value.sort_type === 'price-high-low') {
    filteredProducts.sort((a, b) => b.price - a.price)
  }
  else if (filters.value.sort_type === 'newest') {
    filteredProducts.sort((a, b) => {
      const dateA = a.released_date ? new Date(a.released_date).getTime() : 0
      const dateB = b.released_date ? new Date(b.released_date).getTime() : 0
      return dateB - dateA
    })
  }
  else if (filters.value.sort_type === 'oldest') {
    filteredProducts.sort((a, b) => {
      const dateA = a.released_date ? new Date(a.released_date).getTime() : 0
      const dateB = b.released_date ? new Date(b.released_date).getTime() : 0
      return dateA - dateB
    })
  }
  // Default sorting: sort ASC by product.id if no other sort_type is active
  else {
    filteredProducts.sort((a, b) => Number(a.id) - Number(b.id))
  }


  // If searching, apply search filter to the current filtered list
  if (filters.value.search_input.length > 0) {
    const searchTerm = filters.value.search_input.toLowerCase().trim()
    filteredProducts = filteredProducts.filter(product => {
      return (
        product.name.toLowerCase().includes(searchTerm) ||
        product.speed_black.toString().toLowerCase().includes(searchTerm) ||
        product.speed_color.toString().toLowerCase().includes(searchTerm) ||
        product.description.toLowerCase().includes(searchTerm) ||
        product.model_number.toLowerCase().includes(searchTerm)
      )
    })
  }

  return filteredProducts
})

const PaginatedProducts = computed(() => {
  const start = (active_page.value - 1) * filters.value.page_limit
  const end = start + filters.value.page_limit
  return FilteredProducts.value.slice(start, end)
})

const ActiveItemsShown = computed(() => {
  if (!FilteredProducts.value.length) return "0 of 0 items"

  const start = (active_page.value - 1) * filters.value.page_limit + 1
  let end = start + filters.value.page_limit - 1
  end = Math.min(end, FilteredProducts.value.length)

  return `Showing ${start}-${end} of ${FilteredProducts.value.length} Products`
})

const TotalPages = computed(() => {
  return Math.ceil(FilteredProducts.value.length / filters.value.page_limit)
})

// Watchers
watch(products, () => {
  AddToCartFromURL()
  ConfigureFromURL()
  SetBrandFromURL()
})

// Lifecycle Hooks
store.FetchCatalogData()

onMounted(() => {
  // Set the AI Assistant config
  store.SetAiAssistantConfig()

  // Lifecycle Hooks
  store.FetchCatalogData()

  // Detect if device is mobile
  DetectScreenSize()
  window.addEventListener('resize', () => {
    DetectScreenSize()
  })

  // Start emitting to Analytics
  if (typeof (window as any).gtag === 'function') {
    (window as any).gtag('event', 'page_view', {
      page_path: '/products',
      page_title: 'Catalog Page'
    })
    console.log("Catalog now emits page visits to Analytics.")
  }
})
</script>
<style lang="scss">
.catalog-app {
  .pagination-wrap {
    max-width: 700px;
    margin: auto;
    margin-top: 30px;
  }

  .search-box.v-input--horizontal {
    margin: 0 !important;
    padding: 0 !important;
    min-height: 0;
    height: 40px;
  }
}

.page-sorting {
  position: relative;
  max-width: 218px;
  display: flex;
  padding-bottom: 5px;
  align-items: center;

  .v-select__selection-text {
    position: relative;
    font-weight: 500;
    color: #000;
  }
}

.catalog-pagination {
  max-width: 500px;
  display: block;
  margin: auto;

  .v-pagination__item--is-active button {
    background-color: #1664C0 !important;
    color: #ffffff !important;
  }
}
</style>
